export default __webpack_public_path__ + "static/media/map7.27a33683.png";